/**
 * Makes the entire product card clickable: click anywhere on the card
 * navigates to the product page, unless the click is on a link/button/input.
 * Uses capture so we run first; we only navigate when the target is not interactive.
 */
(function () {
  var INTERACTIVE = 'a, button, input, select, textarea, [role="button"], [role="link"], modal-dialog, details';

  document.body.addEventListener('click', function (e) {
    var card = e.target.closest('[data-product-card-url]');
    if (!card) return;

    var url = card.getAttribute('data-product-card-url');
    if (!url) return;

    if (e.target.closest(INTERACTIVE)) return;

    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }, true);
})();
